export { FETH } from '@f8n/f8n-contracts/dist/abis/FETH.generated';
